import {
  Container,
  Divider,
  Heading,
  Text,
  HStack,
  Stack,
} from "@chakra-ui/react"

import { ButtonLink } from "@/components/Link"
import { AddIcon } from "@/components/Icon"
import AppFooter from "@/components/AppFooter"

import DatasetSummary from "./DatasetSummary"

/**
 *
 * @param datasetDescList
 * @param NavBar
 * @return {JSX.Element}
 * @constructor
 */
const DatasetsPage = ({ datasetDescList, NavBar, deleteDataset }) => {
  const numDatasets = datasetDescList?.length || 0
  return (
    <>
      {NavBar}
      <main>
        <Container maxW="container.lg" minH="100vh">
          <Stack spacing="lg" pt="4rem" pb="xl">
            <HStack spacing="lg" h="4rem">
              <Heading variant="pageTitle">{"All datasets"}</Heading>
              <ButtonLink
                href="/new-dataset"
                size="md"
                colorScheme="brand"
                leftIcon={<AddIcon size="20" />}
                borderRadius="full"
              >
                {"New Dataset"}
              </ButtonLink>
            </HStack>
            <Divider />
            <HStack h="2rem">
              <Text variant="pageSubtitle">{`${numDatasets || "0"} dataset${
                numDatasets === 1 ? "" : "s"
              }`}</Text>
            </HStack>
            <Stack
              spacing="0"
              bg="white"
              borderRadius="md"
              boxShadow="md"
              divider={<Divider />}
            >
              {datasetDescList &&
                datasetDescList.length > 0 &&
                datasetDescList.map((desc) => (
                  <DatasetSummary
                    key={desc.id}
                    title={desc.title}
                    id={desc.id}
                    chartsCount={desc.chartsCount}
                    deleteDataset={deleteDataset}
                  />
                ))}
            </Stack>
          </Stack>
        </Container>
      </main>

      <AppFooter />
    </>
  )
}

export default DatasetsPage
